var _desc, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 182.5,
    height: 152.95199999999997,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 1.6.0-rc.1")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(28.40999999999997 17.229999999999965) scale(0.1 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 395.41 292.775 c 9.76 9.76 9.76 25.59 0 35.35 c -4.88 4.89 -11.28 7.33 -17.68 7.33 c -6.4 0 -12.8 -2.44 -17.68 -7.33 l -7.77 -7.77 v -0.01 l 35.35 -35.35 L 395.41 292.775 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#66645D",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302,199.37 387.63,285 352.28,320.35 352.28,320.36 302,270.07 191.76,159.84 179.74,112.45 227.12,124.47 302,199.35 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#E2E0D0",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 44 360.365 l -14.42 37 h -1.56 c -15.48 0 -28.02 -12.54 -28.02 -28.02 v -8.98 H 44 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#CCCCCC",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 182.43 5.365 l -14.42 37 H 0 v -8.98 c 0 -15.48 12.54 -28.02 28.02 -28.02 H 182.43 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#CCCCCC",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 302 33.385 v 8.98 H 168.01 l 14.42 -37 h 91.55 C 289.46 5.365 302 17.905 302 33.385 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#999999",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 302 360.365 v 8.98 c 0 15.48 -12.54 28.02 -28.02 28.02 H 29.58 l 14.42 -37 H 302 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#999999",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302,270.07 302,360.37 44,360.37 168.01,42.37 302,42.37 302,199.35 227.12,124.47 179.74,112.45 191.76,159.84 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#e0b6e0",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.01,42.37 44,360.37 0,360.37 0,42.37 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#4D4D4D",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(67.40999999999997 17.22999999999996) scale(0.07 0.08)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "501.8,50.51 10.2,50.51 10.2,267.99 104.19,267.99 147.85,311.64 191.51,267.99 501.8,267.99 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#F92859",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.14,307.63 501.8,307.63 501.8,435.77 446.42,435.77 420.7,461.49 394.97,435.77 212.14,435.77 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#75EBE5",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 147.849 321.843 c -2.705 0 -5.298 -1.075 -7.212 -2.987 l -40.672 -40.671 H 10.199 C 4.567 278.184 0 273.618 0 267.985 V 50.507 c 0 -5.633 4.567 -10.199 10.199 -10.199 h 491.602 c 5.632 0 10.199 4.566 10.199 10.199 v 217.478 c 0 5.633 -4.567 10.199 -10.199 10.199 H 195.732 l -40.671 40.671 C 153.147 320.768 150.554 321.843 147.849 321.843 z M 20.398 257.786 h 83.791 c 2.705 0 5.298 1.075 7.212 2.987 l 36.447 36.447 l 36.446 -36.447 c 1.913 -1.912 4.507 -2.987 7.212 -2.987 h 300.096 V 60.707 H 20.398 V 257.786 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#333333",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 440.36 138.257 H 71.64 c -5.632 0 -10.199 -4.566 -10.199 -10.199 c 0 -5.633 4.567 -10.199 10.199 -10.199 h 368.72 c 5.632 0 10.199 4.566 10.199 10.199 S 445.992 138.257 440.36 138.257 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#333333",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 394.709 198.131 H 71.64 c -5.632 0 -10.199 -4.566 -10.199 -10.199 c 0 -5.633 4.567 -10.199 10.199 -10.199 h 323.069 c 5.632 0 10.199 4.566 10.199 10.199 C 404.908 193.565 400.341 198.131 394.709 198.131 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#333333",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 440.36 198.131 h -6.894 c -5.632 0 -10.199 -4.566 -10.199 -10.199 c 0 -5.633 4.567 -10.199 10.199 -10.199 h 6.894 c 5.632 0 10.199 4.566 10.199 10.199 C 450.559 193.565 445.992 198.131 440.36 198.131 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#333333",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.696 471.692 c -2.705 0 -5.298 -1.075 -7.212 -2.987 l -22.737 -22.737 H 212.143 c -5.632 0 -10.199 -4.566 -10.199 -10.199 v -128.14 c 0 -5.633 4.567 -10.199 10.199 -10.199 h 289.657 c 5.632 0 10.199 4.566 10.199 10.199 v 128.141 c 0 5.633 -4.567 10.199 -10.199 10.199 h -51.155 l -22.737 22.737 C 425.995 470.618 423.402 471.692 420.696 471.692 z M 222.343 425.569 h 172.63 c 2.705 0 5.298 1.075 7.212 2.987 l 18.512 18.513 l 18.512 -18.513 c 1.913 -1.912 4.507 -2.987 7.212 -2.987 h 45.182 V 317.828 H 222.343 V 425.569 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#333333",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 449.785 380.998 H 264.159 c -5.632 0 -10.199 -4.566 -10.199 -10.199 s 4.567 -10.199 10.199 -10.199 h 185.626 c 5.632 0 10.199 4.566 10.199 10.199 S 455.417 380.998 449.785 380.998 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#333333",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(54.39999999999998 10) scale(0.07 0.07)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 166.408 293.6 c 0 -13.2 5.2 -25.6 14.4 -34.8 c 9.2 -9.2 21.6 -14.4 34.4 -14.4 c 12.8 0 25.2 5.2 34.4 14.4 c 19.2 19.2 19.2 50.8 0 70 c -9.2 9.2 -21.6 14.4 -34.4 14.4 l 0 0 c -12.4 0 -24.4 -4.8 -33.2 -13.6 l -145.2 147.2 l 24.8 24.8 l 240.8 -92.4 c 20 -8.4 41.2 -32.4 47.6 -53.2 l 42.8 -140.8 l -100.4 -102 l -139.2 43.2 c -20.4 6.4 -44 28.4 -52.4 48.4 l -90.8 244.4 l 24 24.8 l 144.8 -146.8 C 170.808 318 166.408 306 166.408 293.6 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#E9B526",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 166.408 290.8 l -156.4 158.4 l 20.4 20.4 l 145.2 -147.2 c -6 -8.4 -9.2 -18.4 -9.2 -28.8 C 166.408 292.8 166.408 291.6 166.408 290.8 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#FFC52F",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 212.408 244.4 c 0.8 0 2 0 2.8 0 c 10.4 0 20.4 3.2 28.4 9.2 l 93.6 -94.8 l -20 -20.8 L 212.408 244.4 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#FFC52F",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 246.808 326 c 17.6 -17.6 17.6 -46.8 0 -64.4 c -8.4 -8.8 -19.6 -13.2 -31.6 -13.2 s -23.2 4.8 -31.6 13.2 c -8.4 8.4 -13.2 20 -13.2 32 c 0 11.6 4.4 22.8 12.4 31.2 c 0.4 0 0.4 0.4 0.8 0.4 c 0.4 0.4 0.4 0.4 0.4 0.8 c 8.4 8.4 19.6 12.8 31.2 12.8 C 227.208 339.2 238.408 334.4 246.808 326 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#E9B526",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 208.008 248.8 l -36.8 37.6 c -0.4 2.4 -0.8 4.8 -0.8 7.6 c 0 9.6 2.8 18.4 8 26 l 62.4 -63.2 c -7.6 -5.2 -16.4 -8 -25.6 -8 C 212.808 248 210.408 248.4 208.008 248.8 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#FFC52F",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.41,223.2 497.61,131.2 375.21,6.8 284.01,99.2 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#4BB19B",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.81,43.2 320.01,135.2 340.01,156 431.21,63.6 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#61C2AB",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 61.208 508 c -1.2 0 -2 -0.4 -2.8 -1.2 l -53.6 -54.4 c -1.2 -1.2 -1.6 -2.8 -0.8 -4.4 l 91.6 -245.6 c 8.8 -21.6 34 -44.8 56 -52 l 140 -44 c 2 -0.8 4.4 0.4 5.2 2.8 c 0.8 2 -0.4 4.4 -2.8 5.2 l -140 44 c -19.6 6.4 -43.2 28 -51.2 47.2 l -90.8 243.2 l 50 50.8 l 239.6 -92 c 18.8 -8.4 40 -32 46.4 -52 l 43.6 -142 c 0.8 -2 2.8 -3.2 5.2 -2.8 c 2 0.8 3.2 2.8 2.8 4.8 l -43.6 142 c -7.2 22 -30 47.6 -51.2 56.8 l -242 92.8 C 62.008 508 61.608 508 61.208 508 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 215.208 345.2 c -13.6 0 -26.4 -5.2 -36 -14.8 c -9.6 -9.6 -14.8 -22.4 -14.8 -36.4 s 5.2 -26.8 14.8 -36.4 s 22.4 -14.8 36 -14.8 s 26.4 5.2 36 14.8 l 0 0 c 20 20.4 20 52.8 0 72.8 C 241.608 339.6 228.808 345.2 215.208 345.2 z M 215.208 250.4 c -10.8 0 -22 4 -30.4 12.4 c -8 8 -12.8 19.2 -12.8 30.8 c 0 11.6 4.4 22.8 12.8 30.8 c 8 8 18.8 12.8 30.4 12.8 c 11.6 0 22.4 -4.4 30.4 -12.8 c 16.8 -16.8 16.8 -44.4 0 -61.6 C 237.208 254.4 226.008 250.4 215.208 250.4 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 34.008 480.8 c -1.2 0 -2 -0.4 -2.8 -1.2 c -1.6 -1.6 -1.6 -4 0 -5.6 l 148 -150 c 1.6 -1.6 4 -1.6 5.6 0 s 1.6 4 0 5.6 l -148 150 C 36.008 480.4 35.208 480.8 34.008 480.8 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 406.408 230 L 406.408 230 c -1.2 0 -2 -0.4 -2.8 -1.2 L 278.408 102 c -1.6 -1.6 -1.6 -4 0 -5.6 l 94 -95.2 c 0.8 -0.8 1.6 -1.2 2.8 -1.2 l 0 0 c 1.2 0 2 0.4 2.8 1.2 l 125.2 127.2 c 1.6 1.6 1.6 4 0 5.6 l -94 94.8 C 408.408 229.6 407.608 230 406.408 230 z M 286.808 99.2 l 119.6 121.2 l 88.4 -89.2 L 375.208 9.6 L 286.808 99.2 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 379.608 202.4 c -1.2 0 -2 -0.4 -2.8 -1.2 c -1.6 -1.6 -1.6 -4 0 -5.6 l 66.4 -67.2 c 1.6 -1.6 4 -1.6 5.6 0 c 1.6 1.6 1.6 4 0 5.6 l -66.4 67.2 C 381.608 202 380.808 202.4 379.608 202.4 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(54.39999999999998 40.67999999999995) scale(0.09 0.09)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 505.081 196.696 C 478.327 83.909 376.969 0 256 0 C 114.615 0 0 114.616 0 256 c 0 117.865 79.661 217.109 188.074 246.872 L 505.081 196.696 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#843561",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 512 256 c 0 -20.417 -2.403 -40.269 -6.919 -59.304 L 375.131 66.747 L 255.994 303.9 l 62.964 62.964 L 98.599 413.398 l 89.475 89.475 C 209.709 508.811 232.48 512 256 512 C 397.384 512 512 397.385 512 256 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#3A2F4D",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 438.762 383.096 c -15.243 -33.233 -57.23 -60.315 -93.72 -60.315 l -133.565 77.913 l 44.522 77.913 C 331.688 478.608 398.542 440.823 438.762 383.096 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#FF755C",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 166.954 322.781 c -36.49 0 -78.477 27.081 -93.72 60.315 c 40.22 57.727 107.074 95.511 182.764 95.511 v -94.609 L 166.954 322.781 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#FF9356",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 345.041 322.781 c -13.499 35.769 -48.55 61.217 -89.043 61.217 l -22.261 -31.905 l 22.261 -29.312 H 345.041 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#FFEBB4",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 166.954 322.781 c 13.499 35.769 48.55 61.217 89.043 61.217 v -61.217 H 166.954 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#FFFFFF",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 399.583 125.774 c 0 23.463 -9.695 44.655 -25.288 59.826 l -118.3 118.3 l -33.386 -119.702 L 256 67.873 c 15.182 -15.761 36.486 -25.578 60.104 -25.578 C 362.207 42.296 399.583 79.672 399.583 125.774 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#FF4181",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 256 67.873 l -0.001 32.088 l -33.39 84.236 l 33.387 88.22 l -0.001 31.482 l -118.3 -118.3 c -15.583 -15.171 -25.277 -36.363 -25.277 -59.826 c 0 -46.102 37.376 -83.478 83.478 -83.478 C 219.503 42.296 240.818 52.113 256 67.873 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#FF80AB",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 239.968 83.317 c -11.654 -12.098 -27.306 -18.76 -44.072 -18.76 c -33.755 0 -61.217 27.462 -61.217 61.217 c 0 16.651 6.586 32.233 18.546 43.876 l 102.771 102.768 L 256 99.961 L 239.968 83.317 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#FF6196",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(37.39999999999998 32.20999999999997) scale(0.26 0.26)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "290.04,33.29 118.86,204.43 52.32,137.91 0,190.23 118.86,309.07 342.36,85.61 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(17 34.51999999999998) scale(0.1 0.1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#F44336",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 367.709 330.473 c 0 10.287 -8.341 18.618 -18.618 18.618 H 162.909 c -10.287 0 -18.618 -8.332 -18.618 -18.618 V 181.527 c 0 -10.282 8.332 -18.618 18.618 -18.618 h 186.182 c 10.277 0 18.618 8.336 18.618 18.618 V 330.473 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#FFFFFF",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.91,
    y: 181.53,
    rx: 0,
    ry: 0,
    width: 186.18,
    height: 148.94,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#212121",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.24,181.53 162.91,181.53 162.91,329.86 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#5B5C5F",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 321.164 116.364 c 0 -5.139 -4.171 -9.309 -9.309 -9.309 H 200.145 c -5.139 0 -9.309 4.17 -9.309 9.309 v 46.545 h 130.327 V 116.364 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#E2E4E5",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 321.164 349.091 H 190.836 v 46.545 c 0 5.139 4.17 9.309 9.309 9.309 h 111.709 c 5.139 0 9.309 -4.17 9.309 -9.309 V 349.091 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#E2E4E5",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.53,162.91 190.84,144.29 321.16,144.29 330.47,162.91 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#CFD3D4",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.47,349.09 321.16,367.71 190.84,367.71 181.53,349.09 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#CFD3D4",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 335.127 307.2 c 0 2.574 -2.085 4.655 -4.655 4.655 H 181.527 c -2.569 0 -4.655 -2.081 -4.655 -4.655 v -27.927 c 0 -2.569 2.085 -4.655 4.655 -4.655 h 148.945 c 2.569 0 4.655 2.085 4.655 4.655 V 307.2 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#787878",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 181.197 274.618 c -2.392 0 -4.324 2.085 -4.324 4.655 V 307.2 c 0 2.569 1.932 4.655 4.324 4.655 h 56.185 v -37.236 H 181.197 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#26A69A",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.07,293.24 209.46,279.27 209.46,283.93 186.18,283.93 186.18,302.55 209.46,302.55 209.46,307.2 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#FFFFFF",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 206.932 206.578 c 4.999 0 9.84 1.62 11.99 6.191 c 0.652 1.392 0.977 3.016 0.977 4.887 v 22.942 c 0 1.871 -0.326 3.5 -0.977 4.887 c -2.174 4.622 -6.931 6.256 -11.99 6.256 c -4.464 0 -8.839 -1.596 -11.925 -4.952 l 4.426 -5.99 c 1.983 1.89 4.715 4.036 7.433 4.036 c 3.053 0 5.018 -1.215 5.018 -4.231 v -6.516 c -1.68 1.508 -4.622 2.216 -6.777 2.216 c -3.826 0 -6.605 -0.908 -8.341 -2.737 c -1.741 -1.825 -2.611 -4.645 -2.611 -8.467 v -7.433 c 0 -1.825 0.312 -3.43 0.945 -4.822 C 197.19 208.221 201.886 206.578 206.932 206.578 z M 211.884 217.656 c 0 -1.517 -0.451 -2.583 -1.345 -3.193 c -0.898 -0.61 -2.113 -0.912 -3.64 -0.912 c -1.531 0 -2.737 0.303 -3.607 0.912 c -0.87 0.61 -1.313 1.671 -1.313 3.193 v 7.433 c 0 1.522 0.442 2.574 1.313 3.16 c 0.87 0.586 2.076 0.875 3.607 0.875 c 1.527 0 2.742 -0.424 3.64 -1.266 c 0.894 -0.847 1.345 -2.053 1.345 -3.612 V 217.656 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#F0F0F0",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 231.95 219.415 h 8.085 v 9.253 h -8.085 V 219.415 z M 231.95 241.962 h 8.085 v 9.384 h -8.085 V 241.962 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#F0F0F0",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 273.268 232.253 h 5.8 v 7.168 h -5.8 v 11.925 h -8.08 v -11.925 h -15.77 v -5.343 l 11.86 -27.043 h 11.99 V 232.253 z M 265.188 214.142 c 0 0 -6.675 17.636 -6.842 18.115 h 6.842 V 214.142 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#F0F0F0",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 295.81 244.177 h 16.947 v 7.168 h -25.023 v -4.101 c 0 -3.603 0.275 -7.27 1.885 -10.496 c 2.569 -5.129 13.335 -12.972 14.206 -15.053 c 0.819 -1.927 0.856 -5.725 -0.94 -7.168 c -3.887 -3.109 -8.583 -0.251 -11.241 3.975 l -5.213 -5.148 c 1.345 -2.174 3.184 -3.914 5.506 -5.213 c 4.906 -2.746 13.261 -2.816 17.338 1.047 c 4.138 3.919 4.655 12.67 -0.526 18.609 C 302.922 234.408 295.81 236.856 295.81 244.177 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#F0F0F0",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(91.75 117.24)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "ADAMCG PRO",
    fontSize: 40,
    fontWeight: "normal",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#000000",
      fillRule: "nonzero",
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -81.25,
    y: 8.98,
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#000000",
      fillRule: "",
      opacity: 1
    }
  }, "G"), /*#__PURE__*/React.createElement("tspan", {
    x: -52.85,
    y: 8.98,
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#000000",
      fillRule: "",
      opacity: 1
    }
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: -31.74,
    y: 8.98,
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#000000",
      fillRule: "",
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: -19.75,
    y: 8.98,
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#000000",
      fillRule: "",
      opacity: 1
    }
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 3.61,
    y: 8.98,
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#000000",
      fillRule: "",
      opacity: 1
    }
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.88,
    y: 8.98,
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#000000",
      fillRule: "",
      opacity: 1
    }
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 53.95,
    y: 8.98,
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#000000",
      fillRule: "",
      opacity: 1
    }
  }, "h"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.9f86dae36008313351578031944e270a.svg";
export { ForwardRef as ReactComponent };